import { Action } from '@/lib/frontend/store/actions';
import ordersReducer, { Orders } from '@/lib/frontend/store/reducers/currentUser/orders';
import invoicesReducer, { Invoices } from '@/lib/frontend/store/reducers/currentUser/invoices';
import licensesReducer, { Licenses } from '@/lib/frontend/store/reducers/currentUser/licenses';
import { ReducerInputState } from '@/types/store';

export type CurrentUser = {
  orders: Orders;
  invoices: Invoices;
  licenses: Licenses;
};

const defaultState = {
  orders: undefined,
  invoices: undefined,
  licenses: undefined,
};

export default function currentUserReducer(
  state: ReducerInputState<CurrentUser> = defaultState,
  action: Action,
): CurrentUser {
  return {
    orders: ordersReducer(state.orders, action),
    invoices: invoicesReducer(state.invoices, action),
    licenses: licensesReducer(state.licenses, action),
  };
}
